module.exports = __webpack_public_path__ + "static/media/add_icon.780110f4.svg";